import Main from "../../components/main";
import Content from "../../components/content";
import Header from "../../components/header";
import styles from "./index.module.scss";
import { DescList } from "./constans";

export default function GameDesc() {
  return (
    <Main>
      <Header title="玩法说明" className={styles.header}></Header>
      <Content className={styles.content}>
        <div className={styles.descContainer}>
          {DescList.map((content, index) => {
            return (
              <div className={styles.contentItem} key={index}>
                <div className={styles.contentTitle}>{content.title}</div>
                {content.content.map((item, idx) => {
                  return (
                    <div className={styles.contentInner} key={index + idx}>
                      <div className={styles.label}>{item.title}</div>
                      <div className={styles.value}>
                        {Array.isArray(item.text)
                          ? item.text.map((i) => (
                              <div className={styles.text} key={i}>
                                {i}
                              </div>
                            ))
                          : item.text}
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
        </div>
      </Content>
    </Main>
  );
}
